const ecoSystem: string = process.env.REACT_APP_ECO_SYSTEM || "";

export const getUserSurveyPath = (): string => {
  return `$..admin.survey.items`;
};

export const getProjectPath = (projectId: string): string => {
  return `$..admin.project.items.${projectId}`;
};

export const getCADSectionPath = (): string => {
  return `/persistent/static/live/sections`;
};

export const getCADCustomerSectionPath = (): string => {
  return `/persistent/static/admin/customer`;
};

export const getCADProjectSectionPath = (): string => {
  return `$..persistent.static.live.projectSections`;
};

export const getUserRolesPath = (): string => {
  return `$..admin.role`;;
};

export const getVehicleExtendedBioPath = (): string => {
  return `$..admin.vehicleSettings.extendedBio`;;
};

export const getCalendarSettingsPath = (): string => {
  return `$..admin.calendarManagement.items`;
};

export const getVehicleTypesPath = (): string => {
  return `$..admin.vehicleSettings.types`;;
};

export const getLiveUserPath = (): string => {
  return `$..live`;
};

export const getExtendedBioPath = (serviceId: string): string => {
  return `$..persistent.static.${serviceId}.extendedBio`;
};

export const getUserPath =(): string =>{
  return `$..persistent.static`
}